import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'shadow-lg py-2' : 'py-4'
      }`}
      style={{ backgroundColor: '#000000' }}
    >
      <div className="container-custom flex justify-between items-center">
        <Link to="/" className="z-10">
          <Logo />
        </Link>

        <nav className="hidden md:block">
          <ul className="flex space-x-8">
            <li>
              <Link 
                to="/" 
                className={`text-white hover:text-gold transition-colors ${
                  location.pathname === '/' ? 'text-gold font-bold' : ''
                }`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link 
                to="/services" 
                className={`text-white hover:text-gold transition-colors ${
                  location.pathname === '/services' ? 'text-gold font-bold' : ''
                }`}
              >
                Services
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className={`text-white hover:text-gold transition-colors ${
                  location.pathname === '/contact' ? 'text-gold font-bold' : ''
                }`}
              >
                Contact
              </Link>
            </li>
          </ul>
        </nav>

        <button 
          className="md:hidden text-white z-10" 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <div
          className={`fixed inset-0 flex flex-col items-center justify-center transition-all duration-300 ${
            isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
          } md:hidden`}
          style={{ backgroundColor: '#000000' }}
        >
          <nav className="text-center">
            <ul className="flex flex-col space-y-8">
              <li>
                <Link 
                  to="/" 
                  className={`text-2xl text-white hover:text-gold transition-colors ${
                    location.pathname === '/' ? 'text-gold font-bold' : ''
                  }`}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/services" 
                  className={`text-2xl text-white hover:text-gold transition-colors ${
                    location.pathname === '/services' ? 'text-gold font-bold' : ''
                  }`}
                >
                  Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className={`text-2xl text-white hover:text-gold transition-colors ${
                    location.pathname === '/contact' ? 'text-gold font-bold' : ''
                  }`}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;